import React from "react";

import { Checkbox, CheckboxProps } from "antd";

export interface CheckboxSegmentedProps extends CheckboxProps {
  label: string | React.ReactNode;
  className?: string;
}

export const CheckboxSegmented = ({ label, className, ...props }: CheckboxSegmentedProps) => (
  <div className={`checkbox-segmented-container ${className ?? ""}`}>
    <Checkbox {...props}>{label}</Checkbox>
  </div>
);
